import React from 'react';
import { Link } from 'react-router-dom';

import ContactUsForm from '../components/home/ContactUsForm';
import Services from '../components/home/services/Services';
import Button from '../components/shared/Button';
import TechStack from '../components/home/techStack/TechStack';
import Clients from '../components/home/clients/Clients';
import { MapTypes } from '../components/shared/constants/MapTypes';
import MapLocations from '../components/shared/MapLocations';
import SocialMedia from '../components/shared/SocialMedia';
// import Locations from '../components/home/Locations';

import BgTalkUs from '../assets/imgs/bg-talk-us.webp';
import Logo from '../assets/imgs/logo.svg';
import BgHero from '../assets/imgs/bg-hero.webp';
import PhoneIcon from '../assets/imgs/office-phone.png';
import logoamcham from '../assets/imgs/logo-amcham.png';
import logocamtic from '../assets/imgs/logo-camtic.png';
import TalkUsReduce from '../assets/imgs/bg-talk-us-reduce.png';
import Title from '../components/shared/Title';

const Home = () => {
  const mapType = MapTypes.OPERATE;

  return (
    <>
      <div className="md:p-16 p-5 h-128 flex justify-center items-center bg-cover bg-center" style={{ backgroundImage: `url(${BgHero})` }}>
        <div className="text-center items-center flex flex-col justify-center">
          <div className="flex items-center gap-2 mb-2 flex-nowrap">
            <h1 className="text-white-100 font-bold text-3xl sm:text-4xl md:text-5xl">Factor</h1>
            <img src={Logo} alt="logo" className="w-12 h-12 sm:w-20 sm:h-20 md:w-[100px] md:h-[100px]" />
            <h1 className="text-white-100 font-bold text-3xl sm:text-4xl md:text-5xl">Software</h1>
          </div>
          <h2 className="text-center text-white-100 font-semibold text-2xl sm:text-2xl md:text-4xl mb-5">We strive to be your nearshore software technology partner of choice</h2>
          <Link to="/services">
            <Button className="bg-blue-900 text-white-50 hover:bg-mid-blue-900 focus:bg-mid-blue-900 active:bg-mid-blue-900">Explore services</Button>
          </Link>
          <div className="hidden md:block mt-8">
            <SocialMedia />
          </div>
        </div>
      </div>

      <div className="bg-center bg-cover bg-no-repeat md:px-52 py-10 px-10" style={{ backgroundImage: `url(${BgTalkUs})` }}>
        <div className="3xl:max-w-[1500px] inline-block">
          <Title text1="About" text2="Us" colorForText={2} />
          <div className="text-center">
            <p className="text-light-grey-500 text-xl mb-5">
              We strive to be your main nearshore software technology partner. We will support your digital strategy and solve your software development needs by providing you with
              the best nearshore talent through staff augmentation, dedicated teams, and consulting.
            </p>

            <Link to="/about-us">
              <Button className="bg-blue-900 text-white-50 hover:bg-mid-blue-900 focus:bg-mid-blue-900 active:bg-mid-blue-900">
                Learn more about Factor K
              </Button>
            </Link>
          </div>
        </div>
      </div>

      <Services />

      <div className="bg-white py-14 my-20 bg-center bg-cover bg-no-repeat" style={{ backgroundImage: `url(${BgTalkUs})` }}>
        <div className="w-full flex flex-col items-center mx-auto max-w-[1500px]">
          <Title text1="Talk" text2="to Us" colorForText={2} className="md:hidden" />
          <div className="flex flex-col lg:flex-row items-center justify-center w-full gap-10 lg:gap-20">
            <a href="tel:+1(786)574-4150" target="_blank" rel="noreferrer" className="flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left" aria-label="Call United States Office at +1 (786) 574-4150">
              <img alt="phone" src={PhoneIcon} className="w-12 h-12 shadow-lg rounded-full" />
              <div>
                <h2 className="font-semibold text-xl">United States Office</h2>
                <p className="underline text-blue-700">+1 (786) 574-4150</p>
              </div>
            </a>

            <a href="tel:+50640022595" target="_blank" rel="noreferrer" className="flex flex-col sm:flex-row items-center gap-4 text-center sm:text-left  mt-5 lg:mt-0" aria-label="Call Costa Rica Office at +506 4002-2595">
              <img alt="phone" src={PhoneIcon} className="w-12 h-12 shadow-lg rounded-full" />
              <div>
                <h2 className="font-semibold text-xl">Costa Rica Office</h2>
                <p className="underline text-blue-700">+506 4002-2595</p>
              </div>
            </a>
          </div>
        </div>
      </div>
      <MapLocations mapType={mapType} />
      <div className="bg-center bg-cover bg-no-repeat md:px-52 py-10 px-10" style={{ backgroundImage: `url(${TalkUsReduce})` }}>
        <div className="3xl:max-w-[1500px] inline-block">
          <Title text1="Our" text2="Affiliations" colorForText={2} />
          <div className="text-center">
            <p className="text-light-grey-700 text-xl mb-5">
              Our company is committed to the technological and commercial growth of Costa Rica. These alliances allow us to access a global network of innovation and business opportunities.
            </p>

            <div className="flex justify-center items-center gap-10 mt-5">
              <img src={logoamcham} alt="AMCHAM Costa Rica" />
              <img src={logocamtic} alt="CAMTIC" />
            </div>
          </div>
        </div>
      </div>
      <TechStack />
      {/* <Locations /> */}
      <Clients />
      <div id="contact-us">
        <ContactUsForm />
      </div>
    </>
  );
};

export default Home;
